<template>
	<!--<div>
		<v-card-text class="py-0">-->
			<v-container fluid class="pt-0">
				<v-row style="margin-top: 10px;" class="mx-0">
					<!--<v-col cols="12" class="px-0">
						<h2 class="black--text">
							{{ $t('wkt.admin.license.upgrade-account-window.step-1.title') }}
						</h2>
					</v-col>-->
					<v-col cols="12" class="pa-0">
						<span style="font-size: 16px;">
							{{ $t('wkt.admin.license.upgrade-account-window.step-1.subtitle') }}
						</span>
					</v-col>
					<v-col cols="6" class="px-0">
						<span style="font-size: 14px;">{{ $t('wkt.admin.license.upgrade-account-window.step-1.suscription') }}</span>
					</v-col>
					<v-col cols="6" class="px-0">
						<span style="font-size: 14px;">{{ $t('wkt.admin.license.upgrade-account-window.step-1.renewal') }}</span>
					</v-col>
					<v-col cols="6" class="pa-0">
						<span style="font-size: 20px;" class="black--text">{{ currentPlan }}</span>
					</v-col>
					<v-col cols="6" class="pa-0">
						<span style="font-size: 20px;" class="black--text">{{ renewalInfo }}</span>
					</v-col>
					<v-col v-if="showPlan" cols="12" class="px-0 pt-6 pb-0">
						<span style="font-size: 14px;" class="black--text font-weight-bold">
							{{ $t('wkt.admin.license.upgrade-account-window.step-1.license-plan.title') }}
						</span>
						<div class="ml-16">
							<v-radio-group v-model="selectedPlan" row @change="$emit('plan-changed', $event)">
								<v-radio :label="$t('wkt.admin.license.upgrade-account-window.step-1.license-plan.monthly')" :value="1" />
								<v-radio class="ml-12" :label="$t('wkt.admin.license.upgrade-account-window.step-1.license-plan.annual')" :value="2" />
							</v-radio-group>
						</div>
					</v-col>
					<v-col cols="12" :class="'px-0 ' + (showPlan ? 'pt-2' : 'pt-6')">
						<span style="font-size: 14px;" class="black--text font-weight-bold">
							{{ $t('wkt.admin.license.upgrade-account-window.step-1.license-type.title') }}
						</span>
					</v-col>
					<v-col cols="12" class="px-0 my-2 d-flex justify-center">
						<LicenseInfo 
							v-if="showBusiness" 
							:licensingInfo="licensingInfo" 
							:licenseType="constants.LICENSE_TYPE_BUSINESS" 
							:licensePlan="selectedPlan" 
							:selected="selectedType === constants.LICENSE_TYPE_BUSINESS"
							@type-changed="updateSelectedType(constants.LICENSE_TYPE_BUSINESS)" />
						<LicenseInfo 
							v-if="showCorporate" 
							:class="showBusiness ? 'ml-4' : 'ml-0'"
							:licensingInfo="licensingInfo" 
							:licenseType="constants.LICENSE_TYPE_CORPORATE" 
							:licensePlan="selectedPlan" 
							:selected="selectedType === constants.LICENSE_TYPE_CORPORATE"
							@type-changed="updateSelectedType(constants.LICENSE_TYPE_CORPORATE)" />
					</v-col>
				</v-row>
			</v-container>
		<!--</v-card-text>
		<v-divider></v-divider>
		<v-card-actions>
			<v-btn color="#185EA9" text @click="$emit('open-rates')" style="font-size: 0.9em; font-weight: 400;">
				<v-icon small color="#185EA9" class="mr-2">open_in_new</v-icon>
				<span class="text-decoration-underline">{{ $t('wkt.admin.license.upgrade-account-window.step-1.more_info').toUpperCase() }}</span>
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn color="#185EA9" text @click="$emit('step-changed', 1)" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.next').toUpperCase() }}</v-btn>
			<v-btn text @click="$emit('close-dialog')" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
		</v-card-actions>	
	</div>-->
</template>

<script>
import BaseModule from '../../../common/BaseModule.js';
import LicenseInfo from './LicenseInfo';

export default {
    name: 'UpgradePlanStep1',
    mixins: [BaseModule],
	props: ['company','licensingInfo','licenseType','licensePlan'],
	watch: {
		licenseType: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				if (!this.licenseType) {
					this.selectedType = this.company.licenseType === this.constants.LICENSE_TYPE_FREE ? 
						this.constants.LICENSE_TYPE_BUSINESS : this.constants.LICENSE_TYPE_CORPORATE;
					this.$emit('type-changed', this.selectedType);
				} else {
					this.selectedType = newValue;
					//this.$emit('type-changed', this.selectedType);
				}
			}
		},
		licensePlan: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				if (!this.licensePlan) {
					this.selectedPlan = this.constants.LICENSE_PLAN_MONTHLY;
					this.$emit('plan-changed', this.selectedPlan);
				} else {
					if (!this.showPlan) {
						// selector de pago mensual/anual (oculto)
						this.selectedPlan = this.constants.LICENSE_PLAN_ANNUAL;
						this.$emit('plan-changed', this.selectedPlan);
					} else {
						this.selectedPlan = newValue;
						//this.$emit('plan-changed', this.selectedPlan);
					}
				}
			}
		}
	},
	components: {
		LicenseInfo
	},
    data () {
		return {
			selectedType: null,
			selectedPlan: null,
		}
    },
	mounted() {
		/*if (!this.licenseType) {
			this.selectedType = this.company.licenseType === 0 ? 1 : 2;
			this.$emit('type-changed', this.selectedType);
		} else {
			this.selectedType = this.licenseType;
			//this.$emit('type-changed', this.selectedType);
		}

		if (!this.licensePlan) {
			this.selectedPlan = this.company.licensePlan === 0 ? 1 : 2;
			this.$emit('plan-changed', this.selectedPlan);
		} else {
			this.selectedPlan = this.licensePlan;
			//this.$emit('plan-changed', this.selectedPlan);
		}*/
	},
	computed: {
		currentPlan() {
			if (!this.company) {
				return '???';
			}

			let text = '';

			switch (this.company.licenseType) {
				case this.constants.LICENSE_TYPE_FREE: 
					text = this.$t('wkt.admin.license.type-free-description');
					break;
				case this.constants.LICENSE_TYPE_BUSINESS: 
					text = this.$t('wkt.admin.license.type-business-description');
					break;
				case this.constants.LICENSE_TYPE_CORPORATE: 
					text = this.$t('wkt.admin.license.type-corporate-description');
					break;
			}

			text += ' - ';

			switch (this.company.licensePlan) {
				case this.constants.LICENSE_PLAN_FREE: 
					text += this.$t('wkt.admin.license.plan-free-description');
					break;
				case this.constants.LICENSE_PLAN_MONTHLY:
					text += this.$t('wkt.admin.license.plan-monthly-description');
					break;
				case this.constants.LICENSE_PLAN_ANNUAL: 
					text += this.$t('wkt.admin.license.plan-annual-description');
					break;
			}

			return text;
		},
		renewalInfo() {
			if (!this.company) {
				return '???';
			}

			let text = this.formatOnlyDate(this.company.licensePlanExpires);
			
			text += ' - ';

			if (this.company.licensePlanAutonrenew) {
				text += this.$t('wkt.admin.license.plan.renew.automatic');
			} else {
				text += this.$t('wkt.admin.license.plan.renew.manual');
			}

			return text;
		},
		showPlan() {
			return this.company.licenseType === this.constants.LICENSE_TYPE_FREE || (
				this.company.licenseType === this.constants.LICENSE_TYPE_BUSINESS && 
				this.company.licensePlan === this.constants.LICENSE_PLAN_MONTHLY);
},
		showBusiness() {
			return this.company.licenseType === this.constants.LICENSE_TYPE_FREE ||
				(this.company.licenseType === this.constants.LICENSE_TYPE_BUSINESS && 
				this.company.licensePlan === this.constants.LICENSE_PLAN_MONTHLY &&
				this.selectedPlan === this.constants.LICENSE_PLAN_ANNUAL);
		},
		showCorporate() {
			return this.company.licenseType === this.constants.LICENSE_TYPE_FREE ||
				this.company.licenseType === this.constants.LICENSE_TYPE_BUSINESS ||
				(this.company.licenseType === this.constants.LICENSE_TYPE_CORPORATE && 
				this.company.licensePlan === this.constants.LICENSE_PLAN_MONTHLY);
		}
	},
    methods: {
		updateSelectedType(type) {
			this.selectedType = type;
			this.$emit('type-changed', this.selectedType);
		},	
    }
}
</script>